import { createApiActionType } from 'app/store/utils';

const apiType = createApiActionType('log');

export const LOG_TO_BACKEND = apiType('LogToBackend');
